import { render, staticRenderFns } from "./ProgramSingleSession.vue?vue&type=template&id=2b4fd552&scoped=true&"
import script from "./ProgramSingleSession.vue?vue&type=script&lang=js&"
export * from "./ProgramSingleSession.vue?vue&type=script&lang=js&"
import style0 from "./ProgramSingleSession.vue?vue&type=style&index=0&id=2b4fd552&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4fd552",
  null
  
)

export default component.exports